import { IColumnProps, TableERP } from "@finanedi.es/storybook"
import { AmortizacionReadingDtoProps } from "api/DTOs/AmortizacionReadingDto"

interface TableAmortizacionPrestamo {
  items: AmortizacionReadingDtoProps[] | object[]
  isLoading: boolean
  prestamoByIdIsLoading: boolean
  columns: IColumnProps[]
}

const TableAmortizacionesPrestamos = ({
  items,
  isLoading,
  prestamoByIdIsLoading,
  columns,
}: TableAmortizacionPrestamo) => {
  return (
    <TableERP
      data-testid='tabla-prestamo-detail'
      id='tabla-prestamo-detail'
      className='tw-h-full'
      dataKey='creationTime'
      removableSort
      columns={columns}
      value={items}
      scrollable
      lazy
      size='small'
      loading={isLoading || prestamoByIdIsLoading}
      totalRecords={items.length ?? 0}
    />
  )
}

export default TableAmortizacionesPrestamos
